import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=6cd3cade&"
import script from "./ui-select.vue?vue&type=script&lang=js&"
export * from "./ui-select.vue?vue&type=script&lang=js&"
import style0 from "./ui-select.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports